import React from "react";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Expertise from "@/components/Expertise";
import Cibles from "@/components/Cibles";
import Approche from "@/components/Approche";
import NewsPreview from "@/components/NewsPreview";
import Contact from "@/components/Contact";

export default function HomePage() {
  return (
    <>
      <Hero />
      <Marquee />
      <Expertise />
      <Cibles />
      <Approche />
      <NewsPreview />
      <Contact />
    </>
  );
}
